// extracted by mini-css-extract-plugin
export default {"link":"BenefitCategoryCard_link__aUaxL","container":"BenefitCategoryCard_container__vEJBV"};